import { render } from "./extension-table.vue?vue&type=template&id=35388e0c&ts=true"
import script from "./extension-table.vue?vue&type=script&lang=ts"
export * from "./extension-table.vue?vue&type=script&lang=ts"

import "./extension-table.vue?vue&type=style&index=0&id=35388e0c&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__